/* @generated */

// src/assets/ui-icon/line/out-of-office.tsx
import * as React from "react";
var OutOfOfficeLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m15.097 6.185.025.015.017.01.043.025c2.868 1.712 4.057 5.275 2.452 8.055l-.375.65-4.792-2.767L9.68 17H18v1.5H6V17h1.948l3.22-5.577L6.434 8.69l.375-.65c1.62-2.807 5.358-3.546 8.288-1.855Zm1.549 6.668-1.643-.949c.517-1.026.859-2.045.991-2.929.83 1.175 1.076 2.618.652 3.878Zm-4.303-6.022c-.708.557-1.429 1.37-2.067 2.344l-1.728-.997c.905-1.027 2.335-1.536 3.814-1.361l-.018.014Zm1.765.698c.185-.055.26-.03.277-.022l.009.005c.017.012.074.066.118.25.052.216.064.54.002.966-.098.682-.37 1.53-.813 2.425l-2.124-1.226c.554-.832 1.152-1.49 1.694-1.917.339-.267.624-.418.837-.48Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  OutOfOfficeLine
};
